import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, Text } from '@atlaskit/primitives/compiled';

import { LikeIcon } from '../../constants/icons/like';

export const LIKE_REACTION_TYPE = 'like';

export const LikeCount = ({ numberOfLikes }: { numberOfLikes: number }): React.JSX.Element => (
	<Inline space="space.050">
		<LikeIcon />
		<Text size="small" color="color.text.subtlest">
			{numberOfLikes}
		</Text>
	</Inline>
);

export const getLikeCount = (numberOfLikes?: number | null): React.JSX.Element | null => {
	if (!numberOfLikes || numberOfLikes === 0) {
		return null;
	}
	return <LikeCount numberOfLikes={numberOfLikes} />;
};
